import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/chang/Desktop/mj-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import CodeBox from '../../doc-comps/happy-box';
import BasicDemo from './demo/basic';
import BasicDemoCode from '!raw-loader!./demo/basic';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2 {...{
      "id": "tooltip-提示"
    }}>{`Tooltip 提示`}</h2>
    <p>{`提示`}</p>
    <h3 {...{
      "id": "代码演示"
    }}>{`代码演示`}</h3>
    <h4 {...{
      "id": "基本使用"
    }}>{`基本使用`}</h4>
    <CodeBox code={BasicDemoCode} title="" desc="" mdxType="CodeBox">
  <BasicDemo mdxType="BasicDemo"></BasicDemo>
    </CodeBox>
    <h3 {...{
      "id": "api"
    }}>{`API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`默认值`}</th>
        </tr>
      </thead>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      